"use client"

import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { Skeleton } from "antd"

const BannersSkeleton = () => {
  const isDesktop = useIsDesktop()

  return (
    <Skeleton
      paragraph={false}
      active
      styles={{
        title: {
          width: '100%',
          height: !isDesktop ? "13rem" : "26rem",
          margin: 0,
          marginBottom: '3rem'
        }
      }}
    />
  )
}

export default BannersSkeleton